import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { ErrorFilledIcon, CheckCircleFilledIcon, InfoFilledIcon, CancelIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default, { useState } from 'react';
import alertUserOfDeprecatedProps from '../../utils/deprecation.js';
import Button from '../Button.js';
import Grid from '../Grid.js';

var _excluded = ["actions", "as", "children", "className", "includeRail", "data-testid", "type", "canDismiss"];
var LayoutNotification = function LayoutNotification(_ref) {
  var _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? [] : _ref$actions,
    _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    includeRail = _ref.includeRail,
    dataTestId = _ref['data-testid'],
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    _ref$canDismiss = _ref.canDismiss,
    canDismiss = _ref$canDismiss === void 0 ? false : _ref$canDismiss,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('LayoutNotification', otherProps);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  if (!React__default.Fragment) {
    console.error('Hey Canvas User! Layout.Notification requires React.Fragment (React 16+). Please update your version of React or use a polyfill.');
    return null;
  }
  if (actions.length > 2) {
    console.error('Hey Canvas User! Layout.Notification actions should be minimal (2 or less). Consider using Layout.Header and Layout.GlobalActions instead');
  }
  var backgroundFinalClasses = classnames('C-Layout__notificationBackground', _defineProperty({}, "--type-".concat(type), type));
  var finalClasses = classnames('C-Layout__notification', _defineProperty(_defineProperty({}, "--type-".concat(type), type), '--include-rail', includeRail), className);
  var handleDismissNotification = canDismiss ? function () {
    setIsVisible(false);
  } : null;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isVisible && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: backgroundFinalClasses,
    "data-testid": dataTestId ? "".concat(dataTestId, "_Background") : null
  }), /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses
  }, otherProps, {
    "data-testid": dataTestId
  }), (type === 'error' || type === 'alert') && /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "C-Layout__notificationIcon",
    icon: ErrorFilledIcon
  }), type === 'success' && /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "C-Layout__notificationIcon",
    icon: CheckCircleFilledIcon
  }), type === 'info' && /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "C-Layout__notificationIcon",
    icon: InfoFilledIcon
  }), /*#__PURE__*/React__default.createElement(Grid.Container, {
    justify: "space-between",
    align: "center"
  }, /*#__PURE__*/React__default.createElement(Grid.Item, {
    xs: true
  }, children), (actions === null || actions === void 0 ? void 0 : actions.length) > 0 && /*#__PURE__*/React__default.createElement(Grid.Item, null, actions.map(function (action, index) {
    return /*#__PURE__*/React__default.createElement(Button, {
      key: index,
      onClick: action.onClick,
      className: "hc-ml-dense"
    }, action.text);
  })), canDismiss && /*#__PURE__*/React__default.createElement(Button, {
    iconOnly: true,
    onClick: handleDismissNotification,
    "aria-label": "close button"
  }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "C-Layout__notificationIcon",
    icon: CancelIcon
  }))))));
};
LayoutNotification.displayName = 'Layout.Notification';

export { LayoutNotification as default };
